import { EventRegister } from 'react-native-event-listeners';

class TimelineEventsClass {
  eventName = 'onActiveStepYChange';

  subscribe = callBack => {
    EventRegister.addEventListener(this.eventName, callBack);
  };

  emit = value => {
    EventRegister.emit(this.eventName, value);
  };
}

const TimelineEvents = new TimelineEventsClass();

export { TimelineEvents }; // eslint-disable-line import/prefer-default-export
